import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationStart, Router } from "@angular/router";
import { TOAST } from '@commoncore/constants/ToastMessages';
import { UserloginController } from '@commoncore/controller/UserLoginController';
import { GlobalService } from '@commoncore/services/global.service';
import { CUT_COPY_OPERATION } from '@commoncore/services/universal.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { filter } from 'rxjs/operators';



@Component({
  selector: 'lib-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  
})
export class HomeComponent implements OnInit {
  public router: Router;
  implRef: any;
  userLoginController: any = null;
  public homeController: any;
  public universalService: any;
  localStorageSvc: any;
  navigationState;
  shareAccessService:any;
  listService:any;
  contextMenuService:any;
  userData: any;
  enableSocialLogin: boolean;

  @HostListener('window:resize', [])
  resize(){
    var self = this;
    this.universalService.checkDeviceType();
  }
  
  @HostListener("contextmenu", ["$event"])
  defaultContextMenu(event) {
      if(this.universalService.showContextMenu){
        this.contextMenuService.hideCustomContextMenu();
      }
   }

  //  @HostListener("click", ["$event"])
  //   closeMenu(event) {
  //     if(this.universalService.selectedNodes.length == 0 && this.universalService.showContextMenu){
  //       this.contextMenuService.hideCustomContextMenu();
  //     }
  //   }

  @HostListener('click', ['$event'])
  outsideClick(event) {
    if (event.isTrusted){
      let target = $(event.target).closest('.postlogin-leftnav-main');
      if(target.length == 0 && this.universalService.iframeLogin){
        $('.postlogin-leftnav-main').removeClass('postlogin-leftnav-main-full-width');
        $('.NeueHamburger_menu').removeClass('d-none');
        $('.login-profile').removeClass('d-flex');
        this.universalService.showLeftFullMenu = false;
      }
      if (document.getElementById('customContextMenu') && !document.getElementById('customContextMenu').contains(event.target)){
        //clicked outside customContextMenu
        this.contextMenuService.hideCustomContextMenu();
      }
    }
    
    if(($(event.target).attr('id') == 'advc-search') || $(event.target).attr('class')?.includes('NeueDropdown_Active') || $(event.target).attr('class')?.includes('NeueSort') || $(event.target).attr('class')?.includes('NeueExpand') || event.target.parentElement?.id == 'm-go-to-top' || ($(event.target).attr('id') == 'btn-confirm') || this.universalService.popUpToBeOpened != "" || this.universalService.showEnhancedShareLink || this.universalService.showShareWithPeople
      || this.universalService.showFileInfo || this.universalService.showPreview || this.universalService.isMobileDevice || this.universalService.operationInProgress || event.target.parentNode.classList.contains('progress_btn_container')) {
      if(!this.universalService.mobileSelectionModeOn && this.universalService.isMobileDevice && !this.universalService.showPreview && this.universalService.showMobOptionMenu && this.router.url.includes('/home')  && event.target.classList.contains('modal','fade')){
        //when user click three dot menu from recent horizontal panel and then click outside second time three dots are not working to fix this added this check
        this.universalService.selectedNodes = [];
      }else{
        return;
      }
    }
    if(this.universalService.selectedNodes.length == 0 && this.universalService.showContextMenu){
      this.contextMenuService.hideCustomContextMenu();
    }
    if(this.router.url.includes('/memory')) return;
    this.listService.resetObjectSelections()
  }

  //For DOCs, we open preview of MS DOCs in an iframe. To handle key events on iframe, added delegation.
  @HostListener('window:blur', ['$event'])
  onWindowBlur(event: any): void {
    var self = this;
    let iframe = document.getElementById('doceditIframe') as HTMLIFrameElement
    if(iframe) {
      $(iframe.contentWindow.document).on('keydown', function(e) {
        self.handleShortcutKeyEvents(e);
      });
    }
  }

  //Handled TASK - 535515 : Copy operation using keyboard shortcut 
  @HostListener('document:keydown',['$event'])
  onKeyPress(event: KeyboardEvent) {
    this.handleShortcutKeyEvents(event);
  }

  handleShortcutKeyEvents(event) {
    if(this.universalService.isShortcutKeyAllowedForOperation == true && !this.universalService.operationInProgress && !this.universalService.show2FApopUp && (this.universalService.selectedNodes.length > 0 || this.universalService.cutCopiedFilesWithKeyboard.length > 0)) {
      if (event.keyCode == 67 && (event.ctrlKey || event.metaKey || event.key == "Meta" || event.key == "Control")) { // COPY
        event.preventDefault();
        event.stopPropagation();
        this.contextMenuService.hideCustomContextMenu();
        if(this.universalService.selectedNodes.length > 0) {
          this.universalService.cutCopiedFilesWithKeyboardSource = this.universalService.getCurrentViewOfObjects();
          this.universalService.cutCopiedFilesWithKeyboard = this.universalService.selectedNodes;
          this.listService.deSelectAll(event);
          this.listService.applicationRef.tick();
          this.universalService.showToast(TOAST["COPY_ON_CLIPBOARD"], "success");
          this.universalService.cutOrCopyOperationType = CUT_COPY_OPERATION.COPY
        }
      } else if (event.keyCode == 88 && (event.ctrlKey || event.metaKey || event.key == "Meta" || event.key == "Control")) { // MOVE
        event.preventDefault();
        event.stopPropagation();
        this.contextMenuService.hideCustomContextMenu();
        if(this.universalService.selectedNodes.length > 0) {
          this.universalService.cutCopiedFilesWithKeyboardSource = this.universalService.getCurrentViewOfObjects();
          this.universalService.cutCopiedFilesWithKeyboard = this.universalService.selectedNodes;
          this.listService.deSelectAll(event);
          this.listService.applicationRef.tick();
          this.universalService.showToast(TOAST["CUT_TO_CLIPBOARD"], "success");
          this.universalService.cutOrCopyOperationType = CUT_COPY_OPERATION.MOVE
        }
      } else if (event.keyCode == 86 && (event.ctrlKey || event.metaKey || event.key == "Meta" || event.key == "Control")) {  //PASTE
          event.preventDefault();
          event.stopPropagation();
          this.contextMenuService.hideCustomContextMenu();
          if(this.universalService.cutCopiedFilesWithKeyboard.length > 0) {
            this.universalService.cutCopiedFilesWithKeyboardDestination = this.universalService.getCurrentViewOfObjects();
            AppEvents.optionSelected.next({"pasteFiles":true});
          } 
      } else if ((event.key === "Delete" && event.keyCode == 46) || (this.universalService.browserDetails.os.name == "macOS" && event.key === "Backspace" && event.keyCode == 8)) {  //Delete
        this.contextMenuService.hideCustomContextMenu();
        if(this.universalService.selectedNodes.length > 0) {
          event.preventDefault();
          event.stopPropagation();
          this.universalService.popUpToBeOpened = "deletePopUp";
          AppEvents.optionSelected.next({delete: true});
        }
      }
    } else {
      return
    }
  }
   
  constructor(public globalService: GlobalService) {
    this.enableSocialLogin = ENV_CONSTANTS["constants"]["enableSocialLogin"];
    this.setEnvObjects();
  }

  ngOnInit() {
    AppEvents.createNewGlobalObservable();
    AppEvents.createNewBannerSubscriptions();
    this.universalService.fetchLeftMenuJSONContents();
    let classRef = this;
    this.userData = this.localStorageSvc.getUserData(true);
    this.universalService.activeRepo = "main"
    this.userLoginController = UserloginController.getInstance(this.globalService);
    if(!window.location.href.includes("privatefolder"))
    this.universalService.disableModalBackdrop();
    this.implRef = this.userLoginController.userLoginImplementation;
    if(ENV_CONSTANTS["constants"]["enableOfficeForWebPreview"] && !this.router.url.includes('webview') && this.universalService.userLoggedIn){
      this.implRef.getDocumentSupportedFormats();
    }
    this.universalService.checkDeviceType();
    this.userLoginController.setEnvObjects(this.globalService);
    this.listService.setListOptions();
    this.checkIfUserIsLoggedIn();
    setTimeout(() => {
      this.universalService.setWidthforLogin();
    })

    this.router.events.pipe(
      filter(
        (event) => {
          return (event instanceof NavigationStart);
        }
      )).subscribe((event: NavigationStart) => {

        if (event.navigationTrigger == 'popstate' && event != this.navigationState) {
          classRef.globalService.getFolderServiceRef().breadCrumbsList.splice(-1, 1);
          classRef.globalService.getFolderServiceRef().updateFolderNames();
        }
        this.navigationState = event;
      })
  }

  setEnvObjects() {
    this.router = this.globalService.getRouterRef();
    this.universalService = this.globalService.getUniversalServiceRef();
    this.localStorageSvc = this.globalService.getLocalStorageSvcRef();
    this.shareAccessService = this.globalService.getShareAccessServiceRef();
    this.listService = this.globalService.getListServiceRef();
    this.contextMenuService = this.globalService.getContextMenuServiceRef();
  }

  checkIfUserIsLoggedIn(){
    if(this.router.url.includes('webview')){
      this.universalService.showCreateFolderAndUploadButtons = false;
    }
  }

  redirectTo(link){
    let url='';
    if(link == 'faq'){
      url = '/help/home'
    }else if(link == 'htv'){
      url = '/how-to-videos/faq'
    }
    window.open(url,"_blank", "noopener, noreferrer");
  }
}
